// Logger singleton da app web — wirea wrapLoggerWithSentry sobre o JsonLogger
// base quando VITE_SENTRY_DSN está setado, no-op caso contrário.
//
// **Estado atual:** features web hoje ainda não consomem este logger
// (usam toast.error / propagação React / boundary). O singleton existe pra:
//   1. Receptáculo pronto pra primeira feature que precisar de log estruturado
//   2. Garantir que se algum lugar importar `appLogger` direto, ele já vem
//      embrulhado com Sentry — não precisa passar wrapper por DI/contexto
//
// Quando features começarem a chamar appLogger.error(...), captureException
// dispara automaticamente. Hoje, error capture vem só de:
//   - <SentryErrorBoundary> (render errors React)
//   - Sentry.init global handlers (window.onerror / unhandledrejection)
import { createLogger } from './logger.js';
import { wrapLoggerWithSentry } from './sentry-logger.js';

const base = createLogger({
  minLevel: import.meta.env.VITE_APP_ENV === 'development' ? 'debug' : 'info',
});

export const appLogger = import.meta.env.VITE_SENTRY_DSN
  ? wrapLoggerWithSentry(base)
  : base;
